import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';

declare const window: any;
@Injectable({
  providedIn: 'root'
})
export class ProvisioningService {

  public baseUrl: string = '';
  public provisioningPath: string = '';
  private url: string = '';
  private appConfig!: AppConfigurations;

  constructor(private appInitService: AppInitService,
    private http: HttpClient) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.adminApi.baseApiUrl;
    this.provisioningPath = this.appConfig.adminApi.provisioningController;
    this.url = `${this.baseUrl}${this.provisioningPath}`;
  }

  /**
* Gets the excel
* @param user
*/
  public passCSV(formData: any, provisioningType: number): Observable<any> {
    const url2 = `${this.url}/${provisioningType}`;
    return this.http.post<any>(url2, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
